import { Component, OnChanges, SimpleChanges, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';


@Component({
    selector: 'app-ratings-section',
    templateUrl: './ratings-section.component.html',
    styleUrls: ['./ratings-section.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule]
})
export class RatingsSectionComponent implements OnChanges {

  readonly selections = input.required<GuruEntity[]>();
  readonly invalidEntityNames = input.required<string[]>();
  readonly selectionChanged = output<GuruEntity>();
  unitTypeSelection!: GuruEntity;
  systemTypeSelection!: GuruEntity;
  unitVoltageSelection!: GuruEntity;
  electricHeatSelection!: GuruEntity;
  sizeSelection!: GuruEntity;
  coilRowsSelection!: GuruEntity;
  tubeWallThickness!: GuruEntity;
  motorType!: GuruEntity;
  collapsed: boolean = false;
  canExpand: boolean = true;
  private readonly selectionNames: string[] = ['USUnit', 'USSystemType', 'USUnitVoltage', 'USElecHtKw', 'USSize', 'USCoilRows', 'USCoilWallThickness', 'USMotorType'];

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    const filteredSelections: GuruEntity[] = this.selections().filter(selection => this.selectionNames.indexOf(selection.Name) >= 0);
    if (filteredSelections.length === 0) {
      this.collapsed = true;
      this.canExpand = false;
    } else {
      this.unitTypeSelection = this.getSelectionWithName(this.selectionNames[0], filteredSelections);
      this.systemTypeSelection = this.getSelectionWithName(this.selectionNames[1], filteredSelections);
      this.unitVoltageSelection = this.getSelectionWithName(this.selectionNames[2], filteredSelections);
      this.electricHeatSelection = this.getSelectionWithName(this.selectionNames[3], filteredSelections);
      this.sizeSelection = this.getSelectionWithName(this.selectionNames[4], filteredSelections);
      this.coilRowsSelection = this.getSelectionWithName(this.selectionNames[5], filteredSelections);
      this.tubeWallThickness = this.getSelectionWithName(this.selectionNames[6], filteredSelections);
      this.motorType = this.getSelectionWithName(this.selectionNames[7], filteredSelections);
    }
  }

  private getSelectionWithName(name: string, selections: GuruEntity[]): GuruEntity {
    for (const selection of selections) {
      if (selection.Name === name) {
        return JSON.parse(JSON.stringify(selection));
      }
    }
    return undefined!;
  }

  selectedValueChanged(selectionName: string, value: string): void {
    const entity: GuruEntity = new GuruEntity();
    entity.Name = selectionName;
    entity.Value = value;
    this.selectionChanged.emit(entity);
  }

  getExpansionIcon(): string {
    return this.collapsed ? 'arrow_drop_down' : 'arrow_drop_up';
  }

  toggleExpansion(): void {
    if (this.canExpand) {
      this.collapsed = !this.collapsed;
    }
  }

  isInvalidSelection(selectionName: string): boolean {
    return this.invalidEntityNames().indexOf(selectionName) >= 0;
  }

}
